import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Recent } from 'basic-components/icons';

import { settingsMyAccountActions } from 'actions/modules/myAccount';

import ItemBlock from './ItemBlock';

const EMPTY_ARRAY = []
const RECENT_TYPES = settingsMyAccountActions.RECENT_TYPES
const Recents = ({ query = undefined, setExpandedFalse }) => {
  const favoriteGroups = useSelector(state => state.myAccountState.settingsState.favoriteGroups) || EMPTY_ARRAY,
        favoritePipelines = useSelector(state => state.myAccountState.settingsState.favoritePipelines) || EMPTY_ARRAY,
        favoriteInsights = useSelector(state => state.myAccountState.settingsState.favoriteInsights) || EMPTY_ARRAY,
        favoriteDataPreps = useSelector(state => state.myAccountState.settingsState.favoriteDataPreps) || EMPTY_ARRAY,
        currentRecents = useSelector(state => state.myAccountState.settingsState.recents) || EMPTY_ARRAY,
        favorites = useMemo(() => [
          ...currentRecents,
          ...favoriteGroups.filter(fg => currentRecents.findIndex(cr => cr.name === fg.name && cr.groupName === fg.groupName && cr.type === RECENT_TYPES.GROUP) === -1).map(g => ({ ...g, type: RECENT_TYPES.GROUP })),
          ...favoritePipelines.filter(fp => currentRecents.findIndex(cr => cr.name === fp.name && cr.groupName === fp.groupName && cr.type === RECENT_TYPES.PIPELINE) === -1).map(p => ({ ...p, type: RECENT_TYPES.PIPELINE })),
          ...favoriteInsights.map(i => ({ ...i, name: i.fileName.replace(/.json/g, ""), type: RECENT_TYPES.INSIGHT })).filter(fi => currentRecents.findIndex(cr => cr.name === fi.name && cr.groupName === fi.groupName && cr.type === RECENT_TYPES.INSIGHT) === -1),
          ...favoriteDataPreps.filter(fdp => currentRecents.findIndex(cr => cr.name === fdp.name && cr.groupName === fdp.groupName && cr.type === RECENT_TYPES.DATA_PREP) === -1).map(dp => ({ ...dp, type: RECENT_TYPES.DATA_PREP }))
         ], [currentRecents, favoriteGroups, favoritePipelines, favoriteInsights, favoriteDataPreps])

  return (
    <ItemBlock
        currentRecents={favorites}
        query={query}
        setExpandedFalse={setExpandedFalse}
        title="Recents & favorites"
        titleIcon={(
          <Recent 
              color="grey-dark" 
              height={16} 
              width={16} 
          />
        )}

    />
  )
}

Recents.propTypes = {
  query: PropTypes.string,
  setExpandedFalse: PropTypes.func.isRequired
}

export default Recents;